import React from 'react';
import { Label, CustomInput } from 'reactstrap';
import PropTypes from 'prop-types';

const View = ({ view, changeView }) => {
	return (
		<div className="d-flex">
			<Label for="list-view" className="mr-4">
				<CustomInput
					type="radio"
					name="view"
					id="list-view"
					value="list"
					onChange={changeView}
					className="d-inline-block"
					checked={view === 'list'}
				/>
				List View
			</Label>
			<Label for="table-view" className="mr-4">
				<CustomInput
					type="radio"
					name="view"
					id="table-view"
					value="table"
					onChange={changeView}
					className="d-inline-block"
					checked={view === 'table'}
				/>
				Table View
			</Label>
		</div>
	);
};

View.propTypes = {
	view: PropTypes.string.isRequired,
	changeView: PropTypes.func.isRequired
};

export default View;
